import { Controller } from "@hotwired/stimulus";

export default class ParallaxController extends Controller {
	static targets = ["layer"];

	connect() {
		this._onScroll = this._onScroll.bind(this);
		this._raf = null;

		window.addEventListener("scroll", this._onScroll, { passive: true });
		this._update();
	}

	disconnect() {
		window.removeEventListener("scroll", this._onScroll);
		if (this._raf) cancelAnimationFrame(this._raf);
	}

	_onScroll() {
		if (this._raf) return;
		this._raf = requestAnimationFrame(() => {
			this._raf = null;
			this._update();
		});
	}

	_update() {
		const y = window.scrollY || 0;

		for (const layer of this.layerTargets) {
			const speed = Number(layer.dataset.parallaxSpeed || "0.15");
			layer.style.transform = `translate3d(0, ${Math.round(-y * speed)}px, 0)`;
		}
	}
}
